import React from 'react';
import './Card.css';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  padded?: boolean;
  elevated?: boolean;
}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ padded = true, elevated = false, className = '', ...rest }, ref) => (
    <div
      ref={ref}
      className={`a-card ${padded ? 'a-card--padded' : ''} ${elevated ? 'a-card--elevated' : ''} ${className}`.trim().replace(/\s+/g, ' ')}
      {...rest}
    />
  )
);
Card.displayName = 'Card';
